<template>
  <div class="bv-table">
    <div class="table-header">
      <div class="name-column">Voornaam/achternaam</div>
      <div class="company-column">Bedrijfsnaam</div>
      <div class="contact-column">Telefoon/E-mail</div>
      <div class="actions-column">Toegang/Acties</div>
    </div>

    <div
        v-for="(user, index) in users"
        :key="user.id"
        :class="['table-row', index % 2 === 1 ? 'row-alternate' : '']"
    >
      <div class="name-cell">{{ user.firstName }} {{ user.lastName }}</div>
      <div class="company-cell">{{ user.companyName }}</div>
      <div class="contact-cell">
        <div class="phone">{{ user.mobile }}</div>
        <div class="email">{{ user.email }}</div>
      </div>
      <div class="actions-cell">
        <label class="action-checkbox">
          <input
              :disabled="user.id==1"
              type="checkbox"
              :checked="user.canUpload"
              @change="e => handlePermissionChange(user.id, e.target.checked)"
              class="checkbox-input"
          />
          <span class="checkbox-custom"></span>
          <span class="action-label">Bestanden uploaden</span>
        </label>
        <button
            class="export-button"
            tabindex="0"
            @click="handleImport(user.id)"
            type="button"
        >
          <img
              loading="lazy"
              src="/assets/export.svg"
              class="export-icon"
              alt=""
          />
          <span class="export-text">Importeren</span>
        </button>

        <v-switch
            color="primary" class="export-button" :disabled="user.id==1" v-model="user.status" @change="onDelete(user.id)">
          <template v-slot:label v-if="user.updatingUser">
            {{ user.status ? 'uitschakelen' : 'mogelijk maken' }}
            <v-progress-circular
                :indeterminate="user.updatingUser"
                class="ms-2"
                size="24"
            ></v-progress-circular>
          </template>
        </v-switch>
      </div>
    </div>
  </div>

  <UploadModal v-if="showModalImport" :user-id="selectedId" @close="showModalImport = false"
               @fileUploaded="handleFileUpload">
  </UploadModal>
  <DeleteModal @delete="onDelete" v-if="showModal" @close="showModal = false" :user="selectedUser">
  </DeleteModal>
</template>

<script lang="ts" setup>
import {defineComponent, type PropType, ref} from 'vue'
import type {BvUser} from './types'
import DeleteModal from "../components/Modals/DeleteModal.vue";
import UploadModal from "../components/Modals/UploadModal.vue";

const showModalImport = ref(false);
const handleFileUpload = (file: File) => {
  showModalImport.value = false;
  // Handle the uploaded file data here
};
const selectedId = ref(0)
const handleImport = (userId) => {
  selectedId.value = userId
  showModalImport.value = true;

}
const showModal = ref(false);
const props = defineProps({
  users: {
    type: Array as PropType<BvUser[]>,
    required: true
  }
});
const selectedUser = ref(props.users[0])
const onDelete = (id: number) => {
  console.log(id)
  emit('remove-user', id)
}
const showModalEnable = (userId: number) => {
  console.log("showModalEnable")
  console.log(userId)
  onDelete(userId)
}
const emit = defineEmits(['update-permission', 'remove-user']);
const handlePermissionChange = (
    userId: number,
    value: boolean
) => {
  emit('update-permission', userId, value)
}


</script>

<style scoped>
.export-button {
  justify-content: center;
  align-items: center;
  border-radius: 8px;
  display: flex;
  min-height: 32px;
  gap: 8px;
  white-space: nowrap;
  margin: auto 0;
  padding: 4px 8px;
  font: 600 14px/24px Montserrat, sans-serif;
  background: transparent;
  cursor: pointer;
}

.bv-table {
  border-radius: 20px;
  border: 1px solid var(--Neutral-6, #c7c8cc);
  margin-top: 24px;
  width: 100%;
  font-size: 16px;
  color: var(--Neutral-5, #191a1f);
  overflow-x: auto;
}

.table-header {
  display: flex;
  padding: 8px 0;
  border-bottom: 1px solid var(--Neutral-6, #c7c8cc);
  font-size: 14px;
  font-weight: 700;
  line-height: 24px;
  min-width: 1000px;
}

.table-row {
  display: flex;
  padding: 8px 0;
  min-width: 1000px;
}

.row-alternate {
  background-color: rgba(238, 238, 243, 1);
}

.name-column,
.name-cell {
  width: 20%;
  padding: 8px;
  flex-shrink: 0;
}

.company-column,
.company-cell {
  width: 20%;
  padding: 8px;
  flex-shrink: 0;
}

.contact-column,
.contact-cell {
  flex: 1;
  padding: 8px;
  width: 20%;
  min-width: 240px;
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 4px;
}

.actions-column,
.actions-cell {
  width: 450px;
  padding: 8px;
  flex-shrink: 0;
}

.actions-cell {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: 12px;
  font-size: 14px;
  font-weight: 700;
  line-height: 24px;
  color: var(--Gray-2, #2c2c2e);
}

.action-checkbox {
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
}

.checkbox-input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;
}

.checkbox-custom {
  position: relative;
  display: inline-block;
  width: 20px;
  height: 20px;
  background: white;
  border: 2px solid var(--Neutral-6, #c7c8cc);
  border-radius: 4px;
  flex-shrink: 0;
}

.checkbox-input:checked + .checkbox-custom {
  background: var(--Primary, #007AFF);
  border-color: var(--Primary, #007AFF);
}

.checkbox-input:checked + .checkbox-custom::after {
  content: '';
  position: absolute;
  left: 6px;
  top: 2px;
  width: 5px;
  height: 10px;
  border: solid white;
  border-width: 0 2px 2px 0;
  transform: rotate(45deg);
}

.action-button {
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
  display: flex;
  align-items: center;
}

.more-icon {
  width: 24px;
  height: 24px;
}

@media (max-width: 991px) {
  .bv-table {
    margin-top: 16px;
    border-radius: 12px;
  }

  .table-header,
  .table-row {
    padding: 6px 0;
  }

  .name-column,
  .name-cell,
  .company-column,
  .company-cell,
  .contact-column,
  .contact-cell,
  .actions-column,
  .actions-cell {
    padding: 6px;
  }
}
</style>